import React from 'react'
import { Box, Typography, Button, Link } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useStyles } from './Introduction.styles'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import AccentBox from 'src/components/PostGraduationContent/PostgraduateComponents/AccentBox/AccentBox'
import InfoCard from 'src/components/PostGraduationContent/PostgraduateComponents/Cards/InfoCard'

const Introduction = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()

  return (
    <>
      <Typography className={globalClasses.titleSectionVariant2}>
        {t('news.postgraduate.intro.tab-title')}
      </Typography>
      <Box className={classes.contentContainer}>
        <Typography className={classes.paragraph}>
          A UFC e a Lenovo Brasil estão lançando um programa de Residência em
          Segurança Cibernética voltado para a formação de profissionais
          altamente qualificados para atuar na proteção de sistemas,
          infraestruturas e dados em ambientes corporativos e institucionais.
        </Typography>
        <Typography className={classes.paragraph}>
          O curso combina atividades teóricas e práticas, permitindo aos
          participantes desenvolver competências técnicas e experiência em
          projetos reais de pesquisa, desenvolvimento e inovação conduzidos pelo
          Laboratório de Sistemas e Bancos de Dados (LSBD) em parceria com a
          Lenovo.
        </Typography>
        <Typography className={classes.paragraph}>
          As aulas teóricas ocorrerão no Departamento de Computação da UFC,
          enquanto as atividades práticas serão desenvolvidas em laboratórios e
          projetos supervisionados por pesquisadores, professores e
          profissionais da área.
        </Typography>
        <Typography className={classes.paragraph}>
          O curso é inteiramente gratuito e os estudantes selecionados deverão
          dedicar-se integralmente à formação, participando de aulas, estudos,
          avaliações e atividades práticas relacionadas à segurança cibernética.
        </Typography>
        <Typography className={classes.paragraph}>
          Serão ofertadas 12 vagas destinadas à ampla concorrência e 2 vagas
          destinadas a servidores da Universidade Federal do Ceará.
        </Typography>
      </Box>
      <Box className={classes.contentContainer}>
        <Box className={classes.cardGroup}>
          <InfoCard
            title={t('news.postgraduate.intro.info.edital')}
            description={t('news.postgraduate.intro.info.p2')}
          >
            <Link
              className={classes.buttonLink}
              href="https://dc.ufc.br/wp-content/uploads/2026/01/2026-edital-selecao-residencia-seguranca-cibernetica-final.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button variant="contained" className={classes.button}>
                {t('news.postgraduate.intro.info.button')}
              </Button>
            </Link>
          </InfoCard>
          <InfoCard
            title={t('news.postgraduate.sub.results.title')}
            description={t('news.postgraduate.sub.results.call')}
          >
            <Link
              className={classes.buttonLink}
              href="/postgraduate/rsc-2026/resultados"
            >
              <Button variant="contained" className={classes.button}>
                {t('news.postgraduate.sub.results.button')}
              </Button>
            </Link>
          </InfoCard>
        </Box>
      </Box>
      <Box className={classes.contentContainer}>
        <Typography variant="h3" className={globalClasses.titleSectionVariant2}>
          {t('news.postgraduate.intro.info2.title')}
        </Typography>
        <AccentBox email="rsc@lsbd.ufc.br" />
      </Box>
    </>
  )
}

export default Introduction
